import "./ModalVideoLauncherCard.css";
import React from "react";
import Propulator from "higher-order/Propulator";
import PropTypes from "prop-types";
import MarketingVideo from "shared/components/video/MarketingVideo";
import { KEYCODES } from "util/constants";

const ModalVideoLauncherCard = ({
    videoModal,
    videoSource,
    videoPreviewImageSource,
    videoGoogleAnalyticsName,
    logoProps,
    textBodyProps,
    dispatcher
}) => {
    const handleVideoClick = (e) => {
        dispatcher.emit("OPEN_MODAL", {
            modalKey: videoModal.modalKey
        });
    };

    const handleOnKeyUp = (e) => {
        if (e.which === KEYCODES.ENTER) {
            handleVideoClick();
        }
    };

    return (
        <div className="modal-video-launcher-card">
            <MarketingVideo
                videoModal={videoModal}
                src={videoSource}
                gaName={videoGoogleAnalyticsName}
                renderButton={() => (
                    <div className="preview-image-wrapper">
                        <img
                            className="preview-image"
                            alt={"video-preview"}
                            src={videoPreviewImageSource}
                            role="presentation"
                            onClick={handleVideoClick}
                            onKeyUp={handleOnKeyUp}
                        />
                    </div>
                )}
            />
            <div className="logo-wrapper">
                {logoProps && <img alt={logoProps.altText} className="logo" src={logoProps.source} /> }
            </div>
            <div className="marketing-video-body">
                <h2 className="marketing-video-header">{textBodyProps.textBodyHeader}</h2>
                <p className="marketing-video-bodytext">{textBodyProps.textBodyContent}</p>
                <button className="button" onClick={handleVideoClick} onKeyUp={handleOnKeyUp}>
                    <img className="play-button" src={require("../assets/redesign2020/marketing-video-testimonial/play-button.png")} alt="Play Video" />
                    <span>Watch Video</span>
                </button>
            </div>
        </div>
    );
};

ModalVideoLauncherCard.propTypes = {
    videoModal: PropTypes.object.isRequired
};

export default Propulator(ModalVideoLauncherCard, {});